export default {
  title: 'Platby a fakturace',
  subtitle: 'Spravujte peněženku, prohlížejte historii transakcí a faktury',

  wallet: {
    currentBalance: 'Aktuální zůstatek',
    fundsInstant: 'Připsáno hned po potvrzení platby',
    receipts: 'PDF faktura ke každému dobití',
    topUpWallet: 'Dobít peněženku',
  },

  invoices: {
    title: 'Faktury',
    body: 'Faktura se vystavuje ke každému dobití peněženky. Objednávky klíčů se platí z peněženky.',
    topup: 'Dobití peněženky',
    download: 'Faktura PDF',
    empty: 'Zatím žádné faktury — první dobití ji vytvoří.',
  },

  purchaseHistory: {
    title: 'Historie nákupů',
    noPurchases: 'Zatím žádné dokončené nákupy.',
    ranges: {
      all: 'Vše',
      thirtyDays: 'Posledních 30 dní',
      threeMonths: 'Poslední 3 měsíce',
      year: 'Tento rok',
    },
  },

  ledger: {
    title: 'Přehled peněženky',
    noActivity: 'Zatím žádná aktivita peněženky.',
    onHold: 'Blokováno',
    labels: {
      topup: 'Dobití',
      held: 'Blokováno',
      paid: 'Zaplaceno',
      purchase: 'Nákup',
      refund: 'Vrácení peněz',
      adjustment: 'Úprava',
      creditAdjustment: 'Úprava kreditu',
      fee: 'Poplatek',
    },
  },

  topup: {
    title: 'Dobít peněženku',
    amountLabel: 'Částka',
    paymentMethodLabel: 'Způsob platby',
    methods: {
      TRUSTLY: 'Yapili',
      CARD: 'Kreditní / debetní karta',
    },
    redirectNote: 'Budete přesměrováni na našeho zabezpečeného poskytovatele plateb.',
    continue: 'Pokračovat na platbu',
    redirecting: 'Přesměrování…',
    devSkip: 'Dev: přeskočit poskytovatele',
    devBusy: 'Dev dobíjení…',
    errorMinimum: 'Minimální dobití je 1,00 €.',
    errorBillingInfo: 'Před dobíjením vyplňte fakturační údaje v Nastavení.',
    errorGeneric: 'Dobití se nepodařilo zahájit',
    errorDevGeneric: 'Dobití selhalo',
  },
};
